import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTiktok = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M24 12a12 12 0 1 0-24 0 12 12 0 0 0 24 0Z" }), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M13.85 5h-2.5v9.2a2.15 2.15 0 1 1-1.52-2.06V9.5a4.65 4.65 0 1 0 4.02 4.6V9.9a5.9 5.9 0 0 0 3.4 1.08V8.5a3.4 3.4 0 0 1-3.4-3.4Z"
	})]
});
export default SvgTiktok;
